import React, { useState, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./Footer1.scss";
import logo from "../../assets/images/whitelogo.svg";
import offerIcon from "../../assets/images/Discount-Percent-Icon.svg";
import giftIcon from "../../assets/images/giftIcon.svg";
import billIcon from "../../assets/images/billIcon.svg";
import shareIcon from "../../assets/images/shareIcon.svg";
import termsIcon from "../../assets/images/terms-icon.png";
import profileIcon from "../../assets/images/profileIcon.svg";
import ConditionalModalInviteFail from "../ConditionalModal/ConditionalModalInviteFail";
import ConditionalModalInviteSucess from "../ConditionalModal/ConditionalModalInviteSucess";
import ConditionalModalBillSucess from "../ConditionalModal/ConditionalModalBillSucess";
import MyVerticallyCenteredModal from "../MyVerticallyCenteredModal";

const Footer = ({ selected }) => {
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const [failModalShow, setFailModalShow] = useState(false);
  const [failMessage, setFailMessage] = useState("");
  const [successModalShow, setSuccessModalShow] = useState(false);
  const [successModal2Show, setSuccessModal2Show] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const currentYear = new Date().getFullYear();
  
  const modalRef = useRef();
  const handleResetOutside = () => {
    if (modalRef.current) {
      modalRef.current.handleReset();
    }
  }; 
  return (
    <footer>
      <div className="universal_footer">
        <div className="social_media_icon desktop_content">
          <div className="container" style={{ paddingBottom: "12px" }}>
            <div className="row pt-4 pb-4">
              <div className="col-3">
                <div className="footer_logo">
                  <img src={logo} alt="white logo" width={150} height={75} />
                  {/* <div className="medie_icon d-md-flex">
                    <span className="pl-0 pr-0" style={{ paddingLeft: 0 }}>
                      <img className="" src={insta_icon} alt="" />
                    </span>
                    <span>
                      <img src={fb_icon} alt="" />
                    </span>
                    <span>
                      <img src={twt_ion} alt="" />
                    </span>
                    <span>
                      <img src={yt_icon} alt="" />
                    </span>
                  </div> */}
                </div>
              </div>
              <div className="col-1"></div>
              <div className="col-7">
                <div className="footer_row ">
                  <ul className="d-flex px-0">
                    <li
                      style={{
                        color: `${selected === "home" ? "#DB4B41" : "#ffffff"}`,
                        fontWeight: `${selected === "home" ? "700" : "300"}`,
                      }}
                      onClick={() => navigate("/home")}
                    >
                      My Account
                    </li>
                    <li
                      style={{
                        color: `${
                          selected === "tier-history" ? "#DB4B41" : "#ffffff"
                        }`,
                        fontWeight: `${selected === "tier-history" ? "700" : "300"}`,
                      }}
                      onClick={() => navigate("/tier-history")}
                    >
                    Tier Benefits
                    </li>
                    <li
                      style={{
                        color: `${
                          selected === "rewards" ? "#DB4B41" : "#ffffff"
                        }`,
                        fontWeight: `${selected === "rewards" ? "700" : "300"}`,
                      }}
                      onClick={() => navigate("/rewards-catalogue")}
                    >
                      Rewards
                    </li>
                    <li
                      style={{
                        color: `${
                          selected === "feedback" ? "#DB4B41" : "#ffffff"
                        }`,
                        fontWeight: `${
                          selected === "feedback" ? "700" : "300"
                        }`,
                      }}
                      onClick={() => navigate("/feedback")}
                    >
                      Feedback
                    </li>
                  </ul>
                  <p>
                  Welcome to DLF Malls – your ultimate shopping, dining, and entertainment destination! Discover exclusive offers, exciting events, and a world of rewards at DLF Malls. Explore and enjoy a seamless shopping experience!
                  </p>
                </div>
              </div>
              {/* <div className="col-4">
                <div className="d-flex justify-content-end">
                  <div>
                    <input
                      className="form-control newsletter_input"
                      type="text"
                      placeholder="Your Email"
                      aria-label="default input example"
                    />
                  </div>
                  <div>
                    <button className="newsletterbutton">Submit</button>
                  </div>
                </div>
                <div className="text-rigth pt-3">
                  <img src={UPI} alt="" />
                </div>
              </div> */}
            </div>
          </div>
          <div className="copyrigth">
            <p>
              <span className="high_light_text">©{currentYear} DLF MALLS REWARDS </span> |
              All copyrights reserved
            </p>
          </div>
        </div>
        <div className="mobile_content">
          <div className="fixed-bottom">
            <footer className="footer">
              <div className="col">
                <NavLink
                  to="/tier-history"
                  className={({ isActive }) =>
                    isActive ? "active_footer" : ""
                  }
                >
                  <div className="bg_diff">
                    <div className="circle">
                      <img src={offerIcon} alt="" />
                    </div>
                  </div>
                  <p>Tier Benefits</p>
                </NavLink>
              </div>
              <div className="col">
                <NavLink
                  to="/rewards-catalogue"
                  className={({ isActive }) =>
                    isActive ? "active_footer" : ""
                  }
                >
                  <div className="bg_diff">
                    <div className="circle">
                      <img src={giftIcon} alt="" />
                    </div>
                  </div>

                  <p>Rewards</p>
                </NavLink>
              </div>
              <div className="col">
                <MyVerticallyCenteredModal
                  ref={modalRef}
                  show={modalShow}
                  onHide={() => setModalShow(false)}
                  setModalShow={setModalShow}
                  setFailModalShow={setFailModalShow}
                  setFailMessage={setFailMessage}
                  setSuccessModalShow={setSuccessModalShow}
                  setSuccessModal2Show={setSuccessModal2Show}
                  setSuccessMessage={setSuccessMessage}                 
                />
                <NavLink
                  onClick={() => setModalShow(true)}
                  className={({ isActive }) =>
                    isActive ? "active_footer" : ""
                  }
                >
                  <div className="bg_diff">
                    <div className="circle">
                      <img src={billIcon} alt="" />
                    </div>
                  </div>
                  <p>Add Bills</p>
                </NavLink>
              </div>
              <div className="col">
                <NavLink
                  to="/terms"
                  className={({ isActive }) =>
                    isActive ? "active_footer" : ""
                  }
                >
                  <div className="bg_diff">
                    <div className="circle">
                      {/* <img src={shareIcon} alt="" /> */}
                      <img src={termsIcon} alt="" style={{width: "25px", height: "25px"}}/>
                    </div>
                  </div>
                  {/* <p>Share</p> */}
                  <p>TNC</p>
                </NavLink>
              </div>
              <div className="col">
                <NavLink
                  to="/edit-profile"
                  className={({ isActive }) =>
                    isActive ? "active_footer" : ""
                  }
                >
                  <div className="bg_diff">
                    <div className="circle">
                      <img src={profileIcon} alt="" />
                    </div>
                  </div>

                  <p>Profile</p>
                </NavLink>
              </div>
            </footer>
          </div>
        </div>
      </div>
      {failModalShow ? (
        <ConditionalModalInviteFail
          show={true}
          onHide={() => {
            setFailModalShow(false);
            setFailMessage("");
            setModalShow(false);
            handleResetOutside();
          }}
          text={failMessage}
        />
      ) : null}
      {successModalShow ? (
        <ConditionalModalInviteSucess
          show={true}
          onHide={() => {
            setSuccessModalShow(false);
            setSuccessMessage("");
            setModalShow(false);
            handleResetOutside();
          }}
          text={successMessage}
        />
      ) : null}
      {successModal2Show ? (
        <ConditionalModalBillSucess
          show={true}
          onHide={() => {
            setSuccessModal2Show(false);
            setSuccessMessage("");
            setModalShow(false);
            handleResetOutside();
          }}
          text={successMessage}
        />
      ) : null}
    </footer>
  );
};

export default Footer;
